// import React, { createContext, useState } from 'react';

// // Crear el contexto
// export const ThemeContext = createContext();

// // Proveedor de contexto que envuelve a la aplicación
// export const ThemeProvider = ({ children }) => {
//   // const [theme, setTheme] = useState(localStorage.getItem("theme"));
//   console.log(document.documentElement.getAttribute("data-theme"));
  
//   const [theme, setTheme] = useState(document.documentElement.getAttribute("data-theme"));

//   const toggleTheme = () => {
//     setTheme(prevTheme => (prevTheme === 'light' ? 'dark' : 'light'));
//   };

//   return (
//     <ThemeContext.Provider value={{ theme, toggleTheme }}>
//       {children}
//     </ThemeContext.Provider>
//   );
// };

import React, { createContext, useState, useEffect } from 'react';

// Crear el contexto
export const ThemeContext = createContext();

// Proveedor de contexto que envuelve a la aplicación
export const ThemeProvider = ({ children }) => {
  // Inicializar el tema desde localStorage, headers o un valor predeterminado
  const getInitialTheme = () => {
    const storedTheme = localStorage.getItem('theme');
    if (storedTheme) {
      return storedTheme; // Usar tema guardado en localStorage
    }
    const headerTheme = document.documentElement.getAttribute("data-theme"); // Usar atributo HTML (si existe)
    if (headerTheme){
      return headerTheme;
    }
    if (window.matchMedia("(prefers-color-scheme: dark)").matches) {
      return "dark"; // El sistema está en tema oscuro
    } else {
      return "light"; // El sistema está en tema claro
    }
  
  };

  const [theme, setTheme] = useState(getInitialTheme());

  // Sincronizar `data-theme` en el atributo de HTML
  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem('theme', theme); // Guardar tema en localStorage
  }, [theme]);

  // Función para alternar el tema
  const toggleTheme = () => {
    setTheme((prevTheme) => (prevTheme === 'light' ? 'dark' : 'light'));
  };

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};
